import React from 'react';
import { Route } from 'react-router-dom';
import { AREA_CAPABILITIES, ANY_AREA_BUDGET_OR_DAILY } from '../areaCapabilities';
import {
  BudgetDashboard,
  COAManager,
  ExchangeRatesManager,
  BudgetManager,
  BudgetMngLog,
  BudgetSurv,
  BudgetDril,
  BudgetReco,
  PettyCashDashboard,
  NewPettyCash,
  PettyCashFunds,
  PettyCashReports,
  PettyCashFundDetail,
  PettyCashMonthlyReport,
  CorporateExpensesList,
  NewCorporateExpense,
  CompanyAssetsList,
  CompanyAssetNew,
  CompanyAssetDetail,
  ConsolidatedExpenseDashboard,
  DailiesManagement,
  DailySummaryReport,
  DailySurv,
  DailyDril,
  DailyReco,
  DailyMngLog,
  CampLayout,
  SurveyMapPage,
  SurveyPlanningPage,
  SurveyProductionReportsPage,
  RecordingMapPage,
  RecordingPlanningPage,
  RecordingProductionReportsPage,
} from '../lazyComponents';

/** Finance, area budgets, base camp layout, and daily journals. */
export function FinanceBudgetCampDailiesRoutes({ withCapability, withAnyCapability }) {
  return (
    <>
      <Route path="/finance/budget-dashboard" element={withCapability(AREA_CAPABILITIES.finance, <BudgetDashboard />)} />
      <Route path="/finance/coa" element={withCapability(AREA_CAPABILITIES.finance, <COAManager />)} />
      <Route path="/finance/exchange-rates" element={withCapability(AREA_CAPABILITIES.finance, <ExchangeRatesManager />)} />
      <Route path="/finance/petty-cash" element={withCapability(AREA_CAPABILITIES.finance, <PettyCashDashboard />)} />
      <Route path="/finance/petty-cash/new" element={withCapability(AREA_CAPABILITIES.finance, <NewPettyCash />)} />
      <Route path="/finance/petty-cash/funds" element={withCapability(AREA_CAPABILITIES.finance, <PettyCashFunds />)} />
      <Route path="/finance/petty-cash/funds/:fundId" element={withCapability(AREA_CAPABILITIES.finance, <PettyCashFundDetail />)} />
      <Route path="/finance/petty-cash/funds/:fundId/edit" element={withCapability(AREA_CAPABILITIES.finance, <NewPettyCash />)} />
      <Route path="/finance/petty-cash/reports" element={withCapability(AREA_CAPABILITIES.finance, <PettyCashReports />)} />
      <Route path="/finance/petty-cash/reports/monthly" element={withCapability(AREA_CAPABILITIES.finance, <PettyCashMonthlyReport />)} />
      <Route path="/finance/corporate-expenses" element={withCapability(AREA_CAPABILITIES.finance, <CorporateExpensesList />)} />
      <Route path="/finance/corporate-expenses/new" element={withCapability(AREA_CAPABILITIES.finance, <NewCorporateExpense />)} />
      <Route path="/finance/corporate-expenses/:expenseId" element={withCapability(AREA_CAPABILITIES.finance, <CorporateExpensesList />)} />
      <Route path="/finance/company-assets" element={withCapability(AREA_CAPABILITIES.finance, <CompanyAssetsList />)} />
      <Route path="/finance/company-assets/new" element={withCapability(AREA_CAPABILITIES.finance, <CompanyAssetNew />)} />
      <Route path="/finance/company-assets/:assetId" element={withCapability(AREA_CAPABILITIES.finance, <CompanyAssetDetail />)} />
      <Route path="/finance/expenses" element={withCapability(AREA_CAPABILITIES.finance, <ConsolidatedExpenseDashboard />)} />
      <Route path="/budgets/management" element={withAnyCapability(ANY_AREA_BUDGET_OR_DAILY, <BudgetManager />)} />
      <Route path="/budgets/new" element={withAnyCapability(ANY_AREA_BUDGET_OR_DAILY, <BudgetMngLog />)} />
      <Route path="/budgets/edit/:budgetId" element={withAnyCapability(ANY_AREA_BUDGET_OR_DAILY, <BudgetMngLog />)} />
      <Route path="/budgets/survey/new" element={withCapability(AREA_CAPABILITIES.survey, <BudgetSurv />)} />
      <Route path="/budgets/survey/:budgetId" element={withCapability(AREA_CAPABILITIES.survey, <BudgetSurv />)} />
      <Route path="/budgets/drilling/new" element={withCapability(AREA_CAPABILITIES.drilling, <BudgetDril />)} />
      <Route path="/budgets/drilling/:budgetId" element={withCapability(AREA_CAPABILITIES.drilling, <BudgetDril />)} />
      <Route path="/budgets/recording/new" element={withCapability(AREA_CAPABILITIES.recording, <BudgetReco />)} />
      <Route path="/budgets/recording/:budgetId" element={withCapability(AREA_CAPABILITIES.recording, <BudgetReco />)} />
      <Route path="/budgets/basecamp/new" element={withCapability(AREA_CAPABILITIES.basecamp, <BudgetMngLog />)} />
      <Route path="/budgets/basecamp/:budgetId" element={withCapability(AREA_CAPABILITIES.basecamp, <BudgetMngLog />)} />
      <Route path="/basecamp/camp-layout" element={withCapability(AREA_CAPABILITIES.basecamp, <CampLayout />)} />
      <Route path="/survey/map" element={withCapability(AREA_CAPABILITIES.survey, <SurveyMapPage />)} />
      <Route path="/survey/planning" element={withCapability(AREA_CAPABILITIES.survey, <SurveyPlanningPage />)} />
      <Route path="/survey/production-reports" element={withCapability(AREA_CAPABILITIES.survey, <SurveyProductionReportsPage />)} />
      <Route path="/recording/map" element={withCapability(AREA_CAPABILITIES.recording, <RecordingMapPage />)} />
      <Route path="/recording/planning" element={withCapability(AREA_CAPABILITIES.recording, <RecordingPlanningPage />)} />
      <Route path="/recording/production-reports" element={withCapability(AREA_CAPABILITIES.recording, <RecordingProductionReportsPage />)} />

      <Route path="/dailies/management" element={withAnyCapability(ANY_AREA_BUDGET_OR_DAILY, <DailiesManagement />)} />
      <Route path="/summary/:area" element={withAnyCapability(ANY_AREA_BUDGET_OR_DAILY, <DailySummaryReport />)} />
      <Route path="/dailies/survey/new" element={withCapability(AREA_CAPABILITIES.survey, <DailySurv />)} />
      <Route path="/dailies/survey/:dailyId" element={withCapability(AREA_CAPABILITIES.survey, <DailySurv />)} />
      <Route path="/dailies/drilling/new" element={withCapability(AREA_CAPABILITIES.drilling, <DailyDril />)} />
      <Route path="/dailies/drilling/:dailyId" element={withCapability(AREA_CAPABILITIES.drilling, <DailyDril />)} />
      <Route path="/dailies/recording/new" element={withCapability(AREA_CAPABILITIES.recording, <DailyReco />)} />
      <Route path="/dailies/recording/:dailyId" element={withCapability(AREA_CAPABILITIES.recording, <DailyReco />)} />
      <Route path="/dailies/management/new" element={withAnyCapability(ANY_AREA_BUDGET_OR_DAILY, <DailyMngLog />)} />
      <Route path="/dailies/management/:dailyId" element={withAnyCapability(ANY_AREA_BUDGET_OR_DAILY, <DailyMngLog />)} />
      <Route path="/dailies/basecamp/new" element={withCapability(AREA_CAPABILITIES.basecamp, <DailyMngLog />)} />
      <Route path="/dailies/basecamp/:dailyId" element={withCapability(AREA_CAPABILITIES.basecamp, <DailyMngLog />)} />
    </>
  );
}
